import api from '@/api/api';
import audioFile from '@/assets/audios/notification.mp3';
import ManagePatientModal from '@/components/dashboard/liste-patients/manage-patient';
import { closeMenu, open_menu_state, openMenu } from '@/function/function.js';
import { genders } from '@/utils/constants';
import { showToast } from '@/utils/notifications';
import $ from 'jquery';
import Pusher from 'pusher-js';
import { cca_config } from '@/config';

export default {
    name: "navbar",
    components: { ManagePatientModal },
    props: [],
    data() {
        return {
            user_role: 0,
            compte_id: 0,
            user_id: 0,

            all_apps: false,
            menu_state: 0,

            vm_state: open_menu_state,
            queue: [],
            isLoading: false,
            removingId: null,
            patient_data: undefined,
            sexes: genders,
            current_queue: undefined,
            counter: 0,
            remaining_time: {}
        };
    },
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        auth_user(){
            return this.$store.getters['auth_user'];
        },

        refresh() {
            return this.$store.getters['refresh'];
        },
        countdown_info() {
            return this.$store.getters['countdown_info'];
        }
    },

    created() {
        this.subscribe();
    },

    mounted() {
        // this.$store.dispatch('getCountDown').then(() => {
        //     this.calcTimeRemaining()
        // });

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            this.$store.dispatch("getAuthUser", { user_id: this.user_id })
        }

        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);

            if (!$clicked.parents().hasClass("menu-container")) {
                if(t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'user-menu')
                }
            }

            if (!$clicked.parents().hasClass("menu-container")) {
                if (t.menu_state != 0) {
                    $('.all-apps').removeClass('animate-zoomIn');
                    $('.all-apps').addClass('animate-zoomOut');
                    $('.all-apps').fadeOut();
                    t.menu_state = 0;
                }
            }
        });

        this.fetchQueue();
    },

    methods: {
        calcTimeRemaining() {
            this.counter = this.countdown_info.duree_restant.total_secondes
            
            setInterval(() => {
                let total_seconds = this.counter;

                // Convert the remaining time back to days, hours, minutes, and seconds
                let remaining_days = Math.floor(total_seconds / (24 * 60 * 60));
                total_seconds %= (24 * 60 * 60);

                let remaining_hours = Math.floor(total_seconds / (60 * 60));
                total_seconds %= (60 * 60);

                let remaining_minutes = Math.floor(total_seconds / 60);
                let remaining_seconds = total_seconds % 60;

                this.remaining_time = {
                    days: remaining_days,
                    hours: remaining_hours,
                    minutes: remaining_minutes,
                    seconds: remaining_seconds
                }
                
                this.counter -= 1
            }, 1000)
        },

        displayapps(v) {
            if (v == 0) {
                v = 1;
            } else {
                v = 0;
            }
    
            if (this.menu_state == 0) {
                $('.all-apps').fadeIn();
                $('.all-apps').removeClass('animate-zoomOut');
                $('.all-apps').addClass('animate-zoomIn');
            } else {
                $('.all-apps').removeClass('animate-zoomIn');
                $('.all-apps').addClass('animate-zoomOut');
                $('.all-apps').fadeOut();
            }

            this.menu_state = v;
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector) 
        {
            this.vm_state = openMenu.dropMenu(state, selector)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector) 
        {
            this.vm_state = closeMenu.wrapMenu(selector)
        }, 

        async logout()
        {
            localStorage.clear();
            this.$router.push({"path": "/login"})
        },

        switchRole: function(userId,roleId){
            if (roleId == 2 || roleId == 3 || roleId == 7 || roleId == 10 || roleId == 12 || roleId == 11) {
                window.location = this.base_url_clinique
            } else if (roleId == 9 || roleId == 6) {
                window.location = this.base_url_stock
            }else if (roleId == 11) {           // ROLE_RH
                window.location = this.base_url_rh
            } else {
                this.$store.dispatch('switchRole',{userId:userId,roleId:roleId}).then(() => {
                    if (roleId == 1 || roleId == 5) {
                        this.$router.push({"path": "/tableau-de-bord"})
                    } else if (roleId == 14) {
                        this.$router.push({"path": "/tresorerie"})
                    } else {
                        this.$router.push({"path": "/"})
                    }
                })
            }
        },
        

        subscribe () {
          // Enable pusher logging - don't include this in production
        //   Pusher.logToConsole = true;

          if (!cca_config.PUSHER_APP_KEY) {
            // Clé Pusher non configurée — on désactive proprement l'abonnement
            // au lieu de planter avec "You must pass your app key when you instantiate Pusher".
            console.warn('[Pusher] VUE_APP_PUSHER_APP_KEY non défini — abonnement scan désactivé.')
            return
          }

          let pusher = new Pusher(cca_config.PUSHER_APP_KEY, { cluster: cca_config.PUSHER_APP_CLUSTER })
          pusher.subscribe('consultations')
          pusher.bind('scan', data => {
            // Check if data.id already exists in the queue
            let duplicate = this.queue.find(item => item.id === data.id);

            // If it doesn't exist, add it to the queue
            if (!duplicate) {
                this.queue.push(data);
                this.playAudio();
            }
          })
          pusher.bind('queue-removed', data => {
            this.queue = this.queue.filter(item => item.id !== data.id);
          })
        },
        playAudio() {
            try {
                const audio = new Audio(audioFile);
                audio.play();
            } catch (error) {
                console.error('Error playing audio:', error);
            }
        },
        async fetchQueue() {
            const response = await api.clinique().get('/cca-mobile/queues');

            if (response.status === 200) {
                this.queue = response.data;
            }
        },
        onQueueClick(queue) {
            this.current_queue = queue;
            if (queue.status != 'processing') {
                this.updateQueue(queue.id);
            }
            this.closeMenu('queue-dropdown', 'animate-fadeInTop', 'animate-fadeOutTop');

            $('.edit-profil').modal('show');

            this.fetchSimilarPatients(queue.mobile_user.id);
        },
        async updateQueue(id) {
            const response = await api.clinique().put(`/cca-mobile/queues/${id}`, {status: 'processing'});

            if (response.status === 200) {
                // console.log('updateQueue:', response.data);
            }

        },
        async fetchSimilarPatients(mobile_user_id) {
            this.isLoading = true;


            try {
                const response = await api.clinique().get(`/cca-mobile/patients/${mobile_user_id}/similars`);

                if (response.status === 200) {
                    this.isLoading = false;
                    let ccaPatient = response.data.locale_patient;
                    let mobileProfile = response.data.online_patient;

                    if (mobileProfile) {
                        $('.edit-profil-navbar').modal('show');
                        this.transformProfileToPatientData({
                            ...mobileProfile,
                            fullnameExists: ccaPatient.fullnameExists,
                            birthdateExists: ccaPatient.birthdateExists,
                            exists: ccaPatient.phoneExists && (ccaPatient.fullnameExists || ccaPatient.birthdateExists),
                        });
                    } else {
                        console.log('ccaPatient', ccaPatient)
                        console.log('mobileProfile', mobileProfile)
                    }
                }
            } catch (error) {
                if (error.response) {
                    showToast('Une erreur est survenue lors de la récupération des informations du patient', 'error');
                }
                $('#create-new-patient-mobile').modal('hide');
            }
        },
        transformProfileToPatientData(profile) {
            const {
                patient_lastname,
                patient_firstname,
                patient_gender,
                patient_age,
                patient_birthdate,
                patient_birthplace,
                patient_phone,
                patient_adresse,
                patient_profession,
                patient_idcard_type,
                patient_idcard_num,
                patient_nationality,
                patient_email,
            } = profile;

            const genderObject = this.sexes.find(sexe => sexe.specificatif === patient_gender);

            this.patient_data = {
                type_patient: "non_assure",
                country_suffix: this.default_country_code,
                matricule: "",
                nom: patient_lastname || "",
                prenoms: patient_firstname || "",
                sexe: genderObject,
                age: patient_age || "",
                date_naissance: patient_birthdate || "",
                lieu_de_naissance: patient_birthplace || "",
                telephone: this.formatPhoneNumber(patient_phone),
                quartier: patient_adresse || "",
                profession: patient_profession || "",
                numero_cni: patient_idcard_type === 'national_id_card' ? patient_idcard_num : "",
                numero_passeport: patient_idcard_type === 'passport' ? patient_idcard_num : "",
                nationalite: patient_nationality || "",
                email: patient_email || "",
                ...this.initAccompagnantData(),
                ...this.getPersonneAPrevenirData(profile),
                exists: profile.exists,
                fullnameExists: profile.fullnameExists,
                birthdateExists: profile.birthdateExists,
            };
        },
        getPersonneAPrevenirData(profile) {
            const [lastname, firstname] = (profile.contact_person_name || '').split(' ');

            return {
                personne_a_prevenir_nom: lastname || "",
                personne_a_prevenir_prenom: firstname || "",
                personne_a_prevenir_phone: this.formatPhoneNumber(profile.contact_person_phone),
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_profession: "",
            };
        },

        initAccompagnantData() {
            return {
                accompagnant_nom: "",
                accompagnant_prenom: "",
                accompagnant_phone: "",
                accompagnant_filiation: "",
                accompagnant_quartier: "",
                accompagnant_profession: "",
            };
        },

        formatPhoneNumber(phoneNumber) {
            return phoneNumber?.replace(/^\+\d{1,3}/, '') || "";
        },

        paginatePhoneNumber(phoneNumber) {
            const countryCode = phoneNumber.substring(0, 4);
            const phoneNumberWithoutCountryCode = phoneNumber.substring(4);

            const formattedPhoneNumber = phoneNumberWithoutCountryCode.replace(/(\d{2})(?=\d)/g, '$1 ');

            return `${countryCode} ${formattedPhoneNumber}`;
        },

        async onSuccessfullySavedPatient(data) {
            this.$store.dispatch('setRefresh', !this.refresh);
            this.queue = this.queue.filter(item => item.id !== this.current_queue?.id);

            if (this.current_queue !== undefined) {
                await api.clinique().put(`/cca-mobile/queues/${this.current_queue?.id}`, {status: 'completed', patient_id: data.id});
            }
        },

        /**
         * Retire un patient de la file d'attente Scan & Go (entrée abandonnée / non traitée).
         * Côté backend, l'entrée queue est supprimée et — si elle n'a jamais été liée à un
         * dossier patient — la fiche mobile orpheline aussi, ce qui débloque un re-scan ultérieur.
         */
        async removeFromQueue(q) {
            if (!q || this.removingId === q.id) return;

            const fullName = `${q.mobile_user?.lastname || ''} ${q.mobile_user?.firstname || ''}`.trim();
            if (!window.confirm(`Retirer ${fullName || 'ce patient'} de la file d'attente ?`)) return;

            this.removingId = q.id;
            try {
                const response = await api.clinique().delete(`/cca-mobile/queues/${q.id}`);
                if (response.status === 200) {
                    this.queue = this.queue.filter(item => item.id !== q.id);
                    showToast('Patient retiré de la file d\'attente.', 'success');
                }
            } catch (error) {
                const message = error.response?.data?.message || 'Impossible de retirer ce patient de la file d\'attente.';
                showToast(message, 'error');
            } finally {
                this.removingId = null;
            }
        }
    }
};